const PHRASES = ["Everyday things, made clever", "Shop the goods", "Easy Mood"];

export default function BigMarquee() {
  return (
    <div
      data-testid="big-marquee"
      className="overflow-hidden border-y border-line bg-stone py-8 md:py-10"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {PHRASES.map((phrase, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center font-serif text-[9vw] leading-none tracking-tight md:text-[6vw]"
              >
                <span className={`px-8 md:px-12 ${i % 2 === 1 ? "italic text-ember" : "text-ink"}`}>
                  {phrase}
                </span>
                <span className="text-[3vw] text-ember md:text-[2vw]">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
